/*
 * @Author: chengyu
 * @Date: 2022-09-26 20:38:04
 * @Description: 微信小程序请求
 */
// @ts-ignore
import EngineWrapper from 'flyio/dist/npm/engine-wrapper.js';
// @ts-ignore
import _Fly from 'flyio/dist/npm/fly.js';
// @ts-ignore
import adapter from './adapter/wx';
var engine = EngineWrapper(adapter);
export default (function () {
    return new _Fly(engine);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS9yZXF1ZXN0L2h0dHAvd3gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUdILGFBQWE7QUFDYixPQUFPLGFBQWEsTUFBTSxrQ0FBa0MsQ0FBQztBQUM3RCxhQUFhO0FBQ2IsT0FBTyxJQUFJLE1BQU0sdUJBQXVCLENBQUM7QUFFekMsYUFBYTtBQUNiLE9BQU8sT0FBTyxNQUFNLGNBQWMsQ0FBQztBQUVuQyxJQUFNLE1BQU0sR0FBRyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7QUFFdEMsZ0JBQWU7SUFDYixPQUFPLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0FBQzFCLENBQUMsRUFBQyJ9